import React from 'react';
import { OrdersFulfillmentView } from './OrdersFulfillmentView';
import { useOrdersFulfillment } from './useOrdersFulfillment';
export const OrdersFulfillmentContainer = () => {
    const ordersFulfillment = useOrdersFulfillment();
    return (React.createElement(OrdersFulfillmentView, { ordersToManuallyFulfill: ordersFulfillment.ordersToManuallyFulfill, isDownloading: ordersFulfillment.isDownloading, isUploading: ordersFulfillment.isUploading, onDownload: ordersFulfillment.downloadCSV, onUpload: ordersFulfillment.uploadCSV }));
};
